const api = {
  apiEndpoint: "https://danielcarter.cdn.prismic.io/api/v2"
};

module.exports = api;
